const cssVariableKeys = [
  // Colores base
  'blue',
  'indigo',
  'purple',
  'pink',
  'red',
  'orange',
  'yellow',
  'green',
  'teal',
  'cyan',
  'black',
  'white',
  'gray',
  'gray-dark',

  // Paleta semántica
  'primary',
  'secondary',
  'success',
  'info',
  'warning',
  'danger',
  'light',
  'dark',

  // Grises extendidos
  'gray-100',
  'gray-200',
  'gray-300',
  'gray-400',
  'gray-500',
  'gray-600',
  'gray-700',
  'gray-800',
  'gray-900',

  // Breakpoints
  'breakpoint-xs',
  'breakpoint-sm',
  'breakpoint-md',
  'breakpoint-lg',
  'breakpoint-xl',
  'breakpoint-xxl',

  // Tipografía
  'font-sans-serif',
  'font-monospace',
  'font-size-root',
  'font-size-base',
  'font-weight-base',
  'line-height-base',
  'body-color',
  'body-bg',

  // Espaciado
  'spacer',
  'spacer-1',
  'spacer-2',
  'spacer-3',
  'spacer-4',
  'spacer-5',

  // Bordes y radios
  'border-width',
  'border-color',
  'border-radius',
  'border-radius-sm',
  'border-radius-lg',
  'border-radius-xl',

  // Sombras y enlaces
  'box-shadow',
  'box-shadow-sm',
  'box-shadow-lg',
  'link-color',
  'link-hover-color'
]

// Mapeamos las variables para obtener y actualizar los valores con el prefijo --bs-
const cssVariables = cssVariableKeys.map((key) => {
  const varName = `--bs-${key}`
  const value = window
    .getComputedStyle(document.documentElement)
    .getPropertyValue(varName)
    .trim()

  return {
    name: `${key}`,
    value,
    set: (newValue) => {
      document.documentElement.style.setProperty(varName, newValue)
    }
  }
})

export default cssVariables